/*@ngInject*/
const EnvironmentController = function (preferenceModel, appTypeConfigurationModel) {
    const isDemoEnvironment = preferenceModel.get('system.environment.demo'),
        isProdEnvironment = preferenceModel.get('system.environment.production'),
        isDevelopment = (isDemoEnvironment === 'false' && isProdEnvironment === 'false') ? true : false,
        isProduction = (isProdEnvironment === 'true') ? true : false,
        isSystemUser = (appTypeConfigurationModel.getUserType() === 'SystemUser') ? true : false,
        isUnderwritingUser = appTypeConfigurationModel.isUnderwriterWorkstation() || appTypeConfigurationModel.isAgentConsole();

    this.environment = preferenceModel.get('system.environment.name');
    this.showEnvironment = (isUnderwritingUser && isDevelopment) || (isSystemUser && (isDevelopment || isProduction));
};

angular.module('gw-um-header')
    .controller('environmentController', EnvironmentController);

